<template>
  <div id="app" class="container">
    <h1>Control de Tiempos GetPost</h1>

    <div class="card">
      <div class="card-header">
        <h3>Seleccionar Proyecto</h3>
      </div>

      <div class="card-body row">
        <div class="col-md-4 mb-3 text-left">
          <label>Clave:</label>
          <input class="form-control" type="password" placeholder="Clave" v-model="clave" :disabled="habilitaClave">
        </div>

        <div class="col-md-4 mb-3 text-left">
          <label>Proyecto:</label>
          <select class="form-control" v-on:change="getActividad" v-model="proyecto" :disabled="habilitaProyecto">
            <option v-for="proy in proys" v-bind:value="proy.ID">{{ proy.Proyecto }}</option>
          </select>
        </div>

        <div class="col-md-4 mb-3 p-4">
          <a href="#" v-on:click.prevent="nuevoProyecto">Nuevo proyecto</a>
        </div>
      </div>  
    </div>

    <Proyecto v-if="boolAgregarProyecto" />

    <div class="card" v-if="boolActividad">
      <div class="card-header">
        <h3>Seleccionar Actividad</h3>
      </div>

      <div class="card-body row">
        <div class="col-md-4 mb-3 text-left">
          <label>Actividad:</label>
          <select class="form-control" v-on:change="getTiempo" v-model="actividad" :disabled="habilitaActividad">
            <option v-for="actv in actvs" v-bind:value="actv.ID">{{ actv.Actividad }}</option>
          </select>
        </div>

        <div class="offset-md-4 col-md-4 mb-3 p-4">
          <a href="#" v-on:click.prevent="nuevaActividad">Nueva actividad</a>
        </div>
      </div> 
    </div>

    <Actividad v-if="boolAgregarActividad" />

    <div class="card" v-if="boolTiempo">
      <div class="card-header">
        <h3>Tiempos</h3>
      </div>

      <div class="card-body">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Activo</th>
              <th>Tiempo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="tiempo in tiempos">
              <td>{{ tiempo.Nombre }}</td>
              <td>
                <div v-if="tiempo.Activo == true">
                  <div class="activo"></div>
                </div>
                <div v-else>
                  <div class="inactivo"></div>
                </div>
              </td>
              <td>{{ tiempo.Tiempo }}</td>
            </tr>
          </tbody>
        </table>

        <button class="btn btn-success" v-show="boolActivo" v-on:click="iniciaTiempo">Iniciar</button>
        <button class="btn btn-danger" v-show="!boolActivo" v-on:click="finalizaTiempo">Finalizar</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { bus } from './main';
  import axios from 'axios';
  import io from 'socket.io-client';
  import Toastr from 'toastr';
  import Store from './store/index';
  import Actividad from './components/Actividad';
  import Proyecto from './components/Proyecto';

  export default {
    name: 'App',
    components: {
      Actividad,
      Proyecto
    },
    data () {
      return {
        clave: '',
        proyecto: '0',
        actividad: '0',
        proys: [
          {
            ID: 0,
            Proyecto: 'Seleccionar...'
          }
        ],
        actvs: [
          {
            ID: 0,
            Actividad: 'Seleccionar...'
          }
        ],
        tiempos: [],
        // socket: io('http://localhost:49998'),
        socket: io('http://tiempo.getpost.com.mx:49998'),

        boolActividad: false,
        boolAgregarActividad: false,
        boolAgregarProyecto: false,
        boolTiempo: false,
        boolActivo: true,

        habilitaClave: false,
        habilitaProyecto: false,
        habilitaActividad: false
      }
    },
    mounted() {
      // Función para cargar los proyectos que hay
      this.getProyecto();

      // Función que activa cuando alguien inicia el tiempo de trabajo
      this.socket.on('INIT', (data) => {
        var self = this;

        for (var i in self.tiempos) {
          if (data.user == self.tiempos[i].Clv) {
            self.tiempos[i].Activo = true;
          }
        }
      });

      // Función que desactiva cuando alguien detiene el tiempo de trabajo
      this.socket.on('FIN', (data) => {
        var self = this;

        for (var i in self.tiempos) {
          if (data.user == self.tiempos[i].Clv) {
            self.tiempos[i].Activo = false;
          }
        }
      });
    },
    created () {
      var self = this;

      // Cierra la sección de Agregar Proyecto
      bus.$on('AgregarProyecto', () => {
        self.proyecto = '0';
        self.actividad = '0';
        self.actvs = [
          {
            ID: 0,
            Actividad: 'Seleccionar...'
          }
        ];
        self.tiempos = [];

        self.boolActividad = false;
        self.boolAgregarActividad = false;
        self.boolAgregarProyecto = false;
        self.boolTiempo = false;
        self.boolActivo = true;

        self.habilitaClave = false;
        self.habilitaProyecto = false;
        self.habilitaActividad = false;

        self.getProyecto();
      });

      // Cierra la sección de Agregar Actividad
      bus.$on('AgregarActividad', () => {
        self.actividad = '0';
        self.actvs = [
          {
            ID: 0,
            Actividad: 'Seleccionar...'
          }
        ];
        self.tiempos = [];

        self.boolAgregarActividad = false;
        self.boolTiempo = false;
        self. boolActivo = true;

        self.habilitaClave = false;
        self.habilitaProyecto = false;
        self.habilitaActividad = false;

        let e = {
          target: {
            value: self.proyecto
          }
        };

        self.getActividad(e);
      });
    },
    methods: {
      // Función para cargar los proyectos que existen
      getProyecto: function() {
        var self = this;
        var servicio = 'Proyectos';
        var exito = function(response) {
          if (response.data.length == 0) {
            self.proys = [
              {
                ID: 0,
                Proyecto: 'Seleccionar...'
              }
            ];
            Toastr.info('No hay Proyectos para revisar.');
          } else {
            self.proys = [
              {
                ID: 0,
                Proyecto: 'Seleccionar...'
              }
            ];
            for (var i in response.data) {
              self.proys.push(response.data[i]);
            }
          }
        };

        var error = function(error) {
          self.proys = [
            {
              ID: 0,
              Proyecto: 'Seleccionar...'
            }
          ];
          Toastr.error('Problema al cargar los Proyectos.');
        };

        self.servicioGet(servicio, exito, error);
      },

      // Despliega la opción para agregar un nuevo proyecto
      nuevoProyecto: function() {
        this.proyecto = '0';
        this.actividad = '0';
        this.actvs = [
          {
            ID: 0,
            Actividad: 'Seleccionar...'
          }
        ];
        this.tiempos = [];

        this.boolActividad = false;
        this.boolAgregarActividad = false;
        this.boolTiempo = false;
        this.boolActivo = true;

        this.habilitaActividad = false;

        this.boolAgregarProyecto = true;
        this.habilitaClave = true;
        this.habilitaProyecto = true;

        Store.state.clave = this.clave;
      },

      // Función para cargar las actividades que están ligados a la clave de 
      // usuario ingresado
      getActividad: function(e) {
        console.log('e ', e);
        console.log('e.target ', e.target.value);
        var self = this;
        var servicio = 'Actividades';
        var exito = function (response) {
          console.log(response);
          if ((response.data == null) || (response.data[0].Msg == "Error")) {
            self.actvs = [
              {
                ID: 0,
                Actividad: 'Seleccionar...'
              }
            ];
            if (self.proyecto == '0') {
              self.boolActividad = false;
            }
            else {
              self.boolActividad = true;
              Toastr.info('No hay Actividades para revisar.');
            }
          } else {
            self.actvs = [
              {
                ID: 0,
                Actividad: 'Seleccionar...'
              }
            ];
            self.boolActividad = true;
            for (var i in response.data) {
              self.actvs.push(response.data[i]);
            }
          }
        };

        var error = function (error) {
          self.actvs = [
            {
              ID: 0,
              Actividad: 'Seleccionar...'
            }
          ];
          self.boolActividad = false;
          Toastr.error('Problema al cargar las Actividades.');
        };

        let p = {
          proyecto: e.target.value,
          clave: self.clave
        };

        self.proyecto = p.proyecto;

        if (self.clave == '' || self.clave == null) {
          Toastr.error("Debes agregar una clave, en caso de no tener, favor de " + 
            "solicitarlo a algún administrador.");
        } else {
          self.servicioPost(servicio, p, exito, error);
        }
      },

      // Despliega la opción para agregar una nueva actividad
      nuevaActividad: function() {
        this.actividad = '0';
        this.actvs = [
          {
            ID: 0,
            Actividad: 'Seleccionar...'
          }
        ];
        this.tiempos = [];

        this.boolTiempo = false;
        this.boolActivo = true;

        this.boolAgregarActividad = true;
        this.habilitaClave = true;
        this.habilitaProyecto = true;
        this.habilitaActividad = true;

        Store.state.clave = this.clave;
        Store.state.proyecto = this.proyecto;
      },

      // Función para cargar los tiempos de una actividad seleccionada, así como 
      // mostrar los usuarios que participan en dicha actividad y se encuentran 
      // activos o inactivos
      getTiempo: function(e) {
        var self = this;
        var servicio = 'Tiempos';
        var exito = function (response) {
          if ((response.data == null) || (a.actividad == 0)) {
            self.tiempos = [];
            self.boolTiempo = false;
            Toastr.info('No hay Tiempos para revisar.');
          } else {
            self.tiempos = [];
            self.boolTiempo = true;
            for (var i in response.data) {
              self.tiempos.push(response.data[i]);
            }
          }
        };

        var error = function (error) {
          self.tiempos = [];
          self.boolTiempo = false;
          Toastr.error('Problema al cargar los Tiempos.');
        };

        let a = {
          actividad: e.target.value
        };

        self.actividad = a.actividad;

        self.servicioPost(servicio, a, exito, error);
      },

      // Inicia el tiempo para una cierta actividad de un usuario dado
      iniciaTiempo: function() {
        var self = this;
        var servicio = 'Inserta';
        var exito = function (response) {
          if (response.data.Msg == 'Insertado') {
            self.boolActivo = false;

            Toastr.success('Acaba de iniciar el tiempo!');

            self.socket.emit('TIME_INIT', {
              user: self.clave
            });
          } else if (response.data.Msg == 'Error') {
            self.boolActivo = false;

            Toastr.error('Ya está iniciado el tiempo.');
          } else {
            Toastr.error('Hubo un problema con el tiempo.');
          }
        };

        var error = function (error) {
          Toastr.error('Hubo un problema con el tiempo.');
        };

        if (this.boolActivo == true) {
          var t = {
            clave: self.clave,
            actividad: self.actividad,
            tiempo: 0
          };

          self.servicioPost(servicio, t, exito, error);
        } else {
          Toastr.info('No se puede iniciar el tiempo.');
        }
      },

      // Finaliza el tiempo para una cierta actividad de un usuario dado
      finalizaTiempo: function() {
        var self = this;
        var servicio = 'Inserta';
        var exito = function (response) {
          if (response.data.Msg == 'Insertado') {
            self.boolActivo = true;

            Toastr.success('Acaba de finalizar el tiempo!');

            self.socket.emit('TIME_FIN', {
              user: self.clave
            });
          } else if (response.data.Msg == 'Error') {
            self.boolActivo = true;

            Toastr.error('Ya está detenido el tiempo.');
          } else {
            Toastr.error('Hubo un problema con el tiempo.');
          }
        };

        var error = function (error) {
          Toastr.error('Hubo un problema con el tiempo.');
        };

        if (this.boolActivo == false) {
          var t = {
            clave: self.clave,
            actividad: self.actividad,
            tiempo: 1
          };

          self.servicioPost(servicio, t, exito, error);
        } else {
          Toastr.info('No se puede finalizar el tiempo.');
        }
      },

      // Procesa un servicio web de tip GET
      servicioGet: function(servicio, exito, error) {
        var url = 'http://tiempo.getpost.com.mx/WS/Timer' + servicio + '.php';

        axios.get(url, {})
        .then(exito)
        .catch(error);
      },

      // Procesa un servicio web de tip POST
      servicioPost: function(servicio, parametro, exito, error) {
        var url = 'http://tiempo.getpost.com.mx/WS/Timer' + servicio + '.php';

        axios.post(url, parametro)
        .then(exito)
        .catch(error);
      }
    }
  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.activo {
  background-color: green;
  border-radius: 20px;
  width: 20px;
  height: 20px;
  margin: 0 45%;
}

.card {
  margin: 20px 0 20px 0;
}

.inactivo {
  background-color: red;
  border-radius: 20px;
  width: 20px;
  height: 20px;
  margin: 0 45%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue